import { inject } from 'vue';
import type { TrackingService } from '@/common/tracking/TrackingService';
import { trackingKey } from '@/plugins/keys';

export function useTracking(): TrackingService | undefined {
  return inject<TrackingService>(trackingKey);
}
